module.exports = __webpack_public_path__ + "img/spalm.df4c61be.png";